import 'chartjs-plugin-annotation';
import 'chartjs-plugin-style';
import Chart from 'chart.js';

const currency = 'NZD';
const config = {
    type: 'line',
    data: {
        datasets: [{
            backgroundColor: '#79b31d',
            borderColor: '#79b31d',
            fill: false,
            pointRadius: 0,
            pointHoverBackgroundColor: '#79b31d',
            pointHoverBorderColor: '#79b31d',
            pointHoverRadius: 4,
            pointHitRadius: 16,
            data: [],
        }],
    },
    options: {
        responsive: true,
        maintainAspectRatio: false,
        defaultFontFamily: Chart.defaults.global.defaultFontFamily = "'Lato'",
        showXLabels: 10,
        title: {
            display: false,
        },
        legend: {
            display: false,
        },
        scales: {
            xAxes: [{
                gridLines: {
                    display: false,
                },
                type: 'time',
                distribution: 'series',
                ticks: {
                    source: 'data',
                    autoSkip: true,
                    maxTicksLimit: 4,
                },
                time: {
                    unit: 'day',
                    stepSize: 7,
                    displayFormats: {
                        day: 'DD MMM',
                    },
                    tooltipFormat: 'DD MMM YYYY',
                },
            }],
            yAxes: [{
                gridLines: {
                    color: '#eeeef0',
                    drawBorder: false,
                    tickMarkLength: 0,
                },
                ticks: {
                    maxTicksLimit: 5,
                    callback: function (label) {
                        return (label).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                    },
                    padding: 10,
                },
            }],
        },
        tooltips: {
            mode: 'index',
            intersect: false,
            backgroundColor: 'white',
            cornerRadius: 8,
            caretSize: 10,
            caretPadding: 5,
            xPadding: 16,
            yPadding: 12,
            displayColors: false,
            bodyFontColor: '#222222',
            bodyFontSize: 14,
            bodyFontStyle: 'bold',
            shadowOffsetX: 0,
            shadowOffsetY: 3,
            shadowBlur: 8,
            shadowColor: 'rgba(0, 0, 0, 0.12)',
            callbacks: {
                title: function () {
                    return false;
                },
                label: function (item) {
                    const formatted = Number(item.value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                    // eslint-disable-next-line prefer-template
                    return 'Price: ' + formatted + ' ' + currency + ' (' + item.label + ')';
                },
            },
        },
        hover: {
            mode: 'index',
            intersect: false,
            animationDuration: 0,
        },
        elements: {
            line: {
                tension: 0,
            },
        },
    },
    plugins: [{
        afterDraw: function (chart) {
            const ctx = chart.chart.ctx; // eslint-disable-line prefer-destructuring
            const xAxis = chart.scales['x-axis-0'];
            const yAxis = chart.scales['y-axis-0'];

            ctx.beginPath();
            ctx.moveTo(xAxis.left, yAxis.bottom);
            ctx.lineTo(xAxis.right, yAxis.bottom);
            ctx.lineWidth = 3;
            ctx.strokeStyle = '#DFE0E3';
            ctx.stroke();
        },
        afterDatasetsDraw: function (chart) {
            // eslint-disable-next-line no-underscore-dangle
            if (chart.tooltip._active && chart.tooltip._active.length) {
                // eslint-disable-next-line no-underscore-dangle
                const activePoint = chart.tooltip._active[0];
                const ctx = chart.chart.ctx; // eslint-disable-line prefer-destructuring
                const yAxis = chart.scales['y-axis-0'];
                const pos = activePoint.tooltipPosition();
                const bottomY = yAxis.bottom;

                // draw line
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(pos.x, pos.y + 7);
                ctx.lineTo(pos.x, bottomY + 1);
                ctx.setLineDash([5, 5]);
                ctx.lineWidth = 2;
                ctx.strokeStyle = '#1DA5EE';
                ctx.stroke();
                ctx.restore();
            }
        },
    }],
};

export default (function () {
    const chartTopIndices = document.getElementById('chart-top-indices');

    if (chartTopIndices) {
        const chartNzx = chartTopIndices.getContext('2d');
        const values = JSON.parse(document.getElementById('chart-top-indices').getAttribute('data-chartData'));

        if (values) {
            values.map(function (value) {
                config.data.datasets[0].data.push({
                    t: new Date(value.asAt),
                    y: value.amount,
                });
            });
        }

        window.myLine = new Chart(chartNzx, config);
    }
})();
